var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'jsx-dom';
import { attr, memoize } from '@exadel/esl/modules/esl-utils/decorators';
import { TokenListUtils } from '../../../core/utils/token-list';
import { UIPSetting } from '../base-setting/base-setting';
/**
 * Custom setting to add/remove attributes or append values to attribute
 */
export class UIPBoolSetting extends UIPSetting {
    /** Checkbox field to change setting's value */
    get $field() {
        const $field = document.createElement('input');
        $field.type = 'checkbox';
        $field.name = this.label;
        $field.className = this.labelInputClass;
        return $field;
    }
    get $inner() {
        return (React.createElement("label", { class: this.labelFieldClass },
            this.$field,
            React.createElement("span", { class: this.labelMsgClass }, this.label)));
    }
    /** Container element for displaying inconsistency message */
    get $inconsistencyMsg() {
        return React.createElement("span", { className: this.inconsistencyMsgClass });
    }
    connectedCallback() {
        super.connectedCallback();
        this.innerHTML = '';
        this.appendChild(this.$inner);
    }
    applyTo(model) {
        if (this.mode === 'replace')
            return super.applyTo(model);
        const cfg = {
            target: this.target,
            attribute: this.attribute,
            modifier: this,
            transform: this.transform.bind(this, this.getDisplayedValue()),
        };
        model.changeAttribute(cfg);
    }
    /** Function to transform(update) attribute value */
    transform(value, attrValue) {
        if (!attrValue)
            return value || null;
        const attrTokens = TokenListUtils.remove(TokenListUtils.split(attrValue), this.value);
        value && attrTokens.push(this.value);
        return TokenListUtils.join(attrTokens);
    }
    updateFrom(model) {
        super.updateFrom(model);
        const values = model.getAttribute(this.target, this.attribute);
        if (!values.length) {
            this.setInconsistency(this.NO_TARGET_MSG);
        }
        else {
            this.mode === 'replace' ? this.updateReplace(values) : this.updateAppend(values);
        }
    }
    /** Updates setting's value for replace {@link mode} */
    updateReplace(attrValues) {
        if (!TokenListUtils.isAllEqual(attrValues)) {
            return this.setInconsistency(this.MULTIPLE_VALUE_MSG);
        }
        return this.setValue((this.value && attrValues[0] !== this.value) ? null : attrValues[0]);
    }
    /** Updates setting's value for append {@link mode} */
    updateAppend(attrValues) {
        const containsFunction = (val) => TokenListUtils.contains(TokenListUtils.split(val), [this.value]);
        if (attrValues.every(containsFunction))
            return this.setValue(this.value);
        if (!attrValues.some(containsFunction))
            return this.setValue(null);
        return this.setInconsistency(this.MULTIPLE_VALUE_MSG);
    }
    getDisplayedValue() {
        if (this.value) {
            return this.$field.checked ? this.value : false;
        }
        return this.$field.checked ? '' : false;
    }
    setValue(value) {
        if (this.value) {
            this.$field.checked = value === this.value;
        }
        else {
            this.$field.checked = value !== null;
        }
        this.$inconsistencyMsg.remove();
    }
    setInconsistency(msg = this.INCONSISTENT_VALUE_MSG) {
        this.$field.checked = false;
        this.$inconsistencyMsg.innerText = msg;
        this.$inner.append(this.$inconsistencyMsg);
    }
    setDisabled(force) {
        this.$inconsistencyMsg.classList.toggle('disabled', force);
        this.$field.toggleAttribute('disabled', force);
    }
}
UIPBoolSetting.is = 'uip-bool-setting';
__decorate([
    attr({ defaultValue: '' })
], UIPBoolSetting.prototype, "label", void 0);
__decorate([
    attr({ defaultValue: '' })
], UIPBoolSetting.prototype, "value", void 0);
__decorate([
    attr({ defaultValue: 'replace' })
], UIPBoolSetting.prototype, "mode", void 0);
__decorate([
    memoize()
], UIPBoolSetting.prototype, "$field", null);
__decorate([
    memoize()
], UIPBoolSetting.prototype, "$inner", null);
__decorate([
    memoize()
], UIPBoolSetting.prototype, "$inconsistencyMsg", null);
